import { NotItems } from "component/basic/notItems";
import { setDateTime } from "js/function";
import { useNavigate } from "react-router-dom";
import {CarSlideControll, CarSlideItem} from "../product/car";
import {useRef, useState} from "react";
import {CarReviewListStar} from "../product/page";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import {BtnBox, BtnItem} from "../basic/btns";

function MainDataSection(data){
    return (
        <div className={`mainDataSection ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}

function MainDataArea(data){
    return (
        <div className={`mainDataArea ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}


function MainBgItem(data){
    return (
        <div className={`mainBgItem backgroundImg ${data.addClass||""}`} style={{backgroundImage:`url('${data.img}')`}}>
            {(data?.title && data?.subTitle) && (
                <MainDataTitleBox
                    title={data?.title}
                    subTitle={data?.subTitle}
                />
            )}
        </div>
    );
}

function MainSliderMobileBanner({data, addClass, children}){
    const swiperRef = useRef(null);

    return <div className="mainMobileBannerBox">
        <Swiper
            className={addClass||""}
            modules={[Autoplay]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop={true}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
        >
            {data?.map((item, index) => (
                <SwiperSlide>
                    <div className="mainBannerBox">
                        <div className="mainBgItem backgroundImg" aria-label={item?.mobile_image_alt ?? ("메인배너-" + (index + 1))} style={{backgroundImage:`url('${item?.mobile_image_url}')`}}>
                            {(item?.title && item?.sub_title) && (
                                <MainDataTitleBox
                                    title={item?.title}
                                    subTitle={item?.sub_title}
                                />
                            )}
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
        <div className="contentBox">
            {children}
        </div>
    </div>;
}

function MainSliderBanner(data){
    const swiperRef = useRef(null);
    const [current, setCurrent] = useState(1);
    const [isPaused, setIsPaused] = useState(false);

    return (
        <Swiper
            className={data?.addClass||""}
            modules={[Autoplay]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop={true}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            onSlideChange={(swiper) => setCurrent(swiper.realIndex + 1)}
        >
            {data?.data?.map((item, index) => (
                <SwiperSlide>
                    <div className="mainBannerBox">
                        <div className="mainBgItem backgroundImg" aria-label={data?.type === "pc" ? (item.image_alt ?? ("메인 배너-" + (index + 1) )) : (item.mobile_image_alt ?? ("메인 배너-" + (index + 1) ))} style={{backgroundImage:`url('${data?.type === "pc" ? item.image_url : item?.mobile_image_url}')`}}>
                            {(item?.title && item?.sub_title) && (
                                <MainDataTitleBox
                                    title={item?.title}
                                    subTitle={item?.sub_title}
                                />
                            )}
                        </div>
                    </div>
                </SwiperSlide>
            ))}
            {data?.type === "pc" && (
                <div className="mainBannerNavigationBox">
                    <div className="mainBannerNavigationCountBox">
                        <div className="countText currentCount">{current}</div>
                        <div className="countText">/</div>
                        <div className="countText">{data?.data?.length}</div>
                    </div>
                    <div className="mainBannerNavigationPlayBox">
                        <img src={isPaused ? "/assets/images/icon/start.svg" : "/assets/images/icon/stop.svg"} className="playIcon" onClick={() => {
                            if (!swiperRef.current) return;

                            if (isPaused) {
                                swiperRef.current.autoplay.start();
                            } else {
                                swiperRef.current.autoplay.stop();
                            }

                            setIsPaused(!isPaused);
                        }}/>
                        <div className="mainBannerNavigationDotBox">
                            {data?.data?.map((item, index) => (
                                <div className={`mainBannerNavigationDotItem ${(index + 1) === current ? 'active' : ''}`}/>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </Swiper>
    )
}

function MainDataTitleBox(data){
    return (
        <div className={`mainDataTitleBox ${data.addClass||""}`}>
            <h1 className="mainDataTitle" dangerouslySetInnerHTML={{__html:data.title}}/>
            <p className="mainDataSubTitle" dangerouslySetInnerHTML={{__html:data.subTitle}}/>
        </div>
    );
}

function MainCsItemBox(data){
    let navigate = useNavigate();

    return (
        <div className={`mainCsItemBox ${data.addClass||""}`}>
            <button type="button" onClick={()=>{data.func()}} className="mainCsItem_title">{data.title}<img src="/assets/images/basic/move_w.svg"/></button>
            <div className="mainCsItemListBox">
                {data.data && data.data?.length > 0 ? 
                    <>{data?.data && data?.data?.map((item,i)=>(
                        <button type="button" key={i} onClick={()=>{
                            if(data.type === "faq"){
                                sessionStorage.setItem("faqOpen",item.id);
                                navigate("/faq");
                            }else{
                                navigate(`/notice/detail/${item.id}`);
                            }
                        }} className="mainCsItemList">
                            <h2 className="mainCsItemList_title" dangerouslySetInnerHTML={{__html:item.title}}/>
                            <p className="mainCsItemList_text" dangerouslySetInnerHTML={{__html:data.type === "faq" ? `#${item.category}` : setDateTime(item.created_at,"dayyymmddhh",null)}}/>
                        </button>
                    ))}</>
                :
                <NotItems text={`${data.title}이 없습니다.`}/>}
            </div>
        </div>
    );
}

function MainSearchHistory(data){
    const navigate = useNavigate();

    return (
        <div className={`mainHistoryBox ${data.addClass||""}`}>
            <div className="mainHistoryBoxTitle">최근 찾아본 일정</div>
            <div className="mainHistoryItemBox">
                <Swiper
                    spaceBetween={20}
                    slidesPerView={3}
                    autoHeight={false}
                    loop={true}
                    breakpoints={{
                        960: {
                            slidesPerView: 4
                        },
                        1: {
                            slidesPerView: 1.25
                        }
                    }}
                >
                    {data?.data?.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="mainHistoryItem" onClick={() => {
                                navigate("/rent/list",{state: {
                                        filterData:{
                                            addr:"제주국제공항",
                                            startDtm: item?.start_date,
                                            endDtm: item?.end_date,
                                            birth: null,
                                            career: null,
                                            carCategory: [],
                                            insuranceId: item?.insurance_id,
                                            insuranceName: item?.insurance
                                        }
                                    }});
                            }}>
                                <img src="/assets/images/basic/close.svg" className="closeIcon" onClick={() => data?.deleteFunc(item?.id)}/>
                                <div className="mainHistoryItemDate">{setDateTime(item?.start_date, "dayyymmddhhss", "ymdhi")} ~ {setDateTime(item?.end_date, "dayyymmddhhss", "ymdhi")}</div>
                                <div className="mainHistoryItemContents">제주국제공항 | {item?.insurance}</div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    )
}

function MainReviewSlideBox(data){
    const navigate = useNavigate();
    const [pageCount,setPageCount] = useState("01");
    const swiperRef = useRef(null);

    return (
        <div className={`carSlideBox review ${data.addClass||""}`}>
            <div className="carSlide_titleArea">
                <div className="carSlide_titleBox">
                    <p className="carSlide_title" dangerouslySetInnerHTML={{__html:data.title}}/>
                    <p className="carSlide_subTitle" dangerouslySetInnerHTML={{__html:data.subTitle}}/>
                </div>
                <button type="button" onClick={()=>{ navigate("/reservation") }} className="header_memberBtn">
                    <div className="header_memberBtn_itemsBox">
                        <div className="header_memberBtn_items">
                            리뷰 쓰러가기
                            <img src="/assets/images/icon/btn_move.svg"/>
                        </div>
                    </div>
                </button>
            </div>
            <div className={`carSlide ${data.addClass||""} ${data.data && data.data?.length > 0 ? "" : "carSlide_notItem"}`}>
                {data.data && data.data?.length > 0 ?
                    <div className="carSlideItemBox">
                        <Swiper
                            spaceBetween={20}
                            slidesPerView={3}
                            autoHeight={false}
                            loop={true}
                            breakpoints={{
                                960: {
                                    slidesPerView: 3
                                },
                                1: {
                                    slidesPerView: 1.25
                                }
                            }}
                            onRealIndexChange={(e) => {
                                setPageCount(e.realIndex + 1 < 10 ? `0${e.realIndex + 1}` : e.realIndex + 1);
                            }}
                            ref={swiperRef}
                        >
                            {data.data && data.data?.map((item, i) => (
                                <SwiperSlide key={i}>
                                    <MainReviewItem item={item}/>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <CarSlideControll swiperRef={swiperRef}/>
                    </div>
                    :
                    <NotItems addClass="sectionMinNotItem" text={data.notListText}/>
                }
            </div>
        </div>
    );
}

function MainReviewItem(data){
    return (<div className="mainReviewItemBox">
        <img src={data?.item?.image_url} alt={data?.item?.image_alt ?? ("리뷰모델이미지-" + data?.item?.id)} className="mainReviewItemCarImage"/>
        <CarReviewListStar grade={data?.item?.grade||0}/>
        <div className="mainReviewItemTitleBox">
            <div className="mainReviewItemMainTitle">{data?.item?.model_name} | {data?.item?.name}</div>
            <div className="mainReviewItemDate">{setDateTime(data?.item?.created_at, "yymmdd", "hymd")}</div>
        </div>
        <div className="mainReviewItemContentsBox">{data?.item?.contents}</div>
    </div> )
}

export {MainDataSection,MainDataArea,MainDataTitleBox,MainCsItemBox,MainBgItem,MainSearchHistory,MainReviewSlideBox,MainSliderBanner,MainSliderMobileBanner}